import React, { useState } from "react"
import { Button } from "src/components/ui/button"
import { Input } from "src/components/ui/input"
import { Textarea } from "src/components/ui/textarea"
import { FormItem, FormLabel, FormMessage } from "src/components/ui/form"

const DEFAULT_COLOR = "#64748B"
const PRESET_COLORS = [
  "#ef4444", "#f97316", "#eab308", "#22c55e", "#14b8a6",
  "#3b82f6", "#8b5cf6", "#ec4899", "#64748b", "#0f172a",
]

export function TagForm({ tag, onSubmit, onCancel, isPending }) {
  const [name, setName] = useState(tag?.name || "")
  const [color, setColor] = useState(tag?.color || DEFAULT_COLOR)
  const [description, setDescription] = useState(tag?.description || "")
  const [errors, setErrors] = useState({})

  function validate() {
    const e = {}
    if (!name.trim()) e.name = "Name is required"
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color)) e.color = "Must be a valid hex color (e.g. #3b82f6)"
    return e
  }

  function handleSubmit(e) {
    e.preventDefault()
    const e2 = validate()
    if (Object.keys(e2).length) { setErrors(e2); return }
    onSubmit({ name: name.trim(), color, description: description.trim() || undefined })
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-1 flex-col overflow-hidden">
      <div className="flex-1 space-y-5 overflow-y-auto px-6 py-5">

        <FormItem>
          <FormLabel>Name</FormLabel>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Hot Lead"
            maxLength={60}
          />
          {errors.name && <FormMessage>{errors.name}</FormMessage>}
        </FormItem>

        <FormItem>
          <FormLabel>Color</FormLabel>
          <div className="space-y-2">
            {/* Preset swatches */}
            <div className="flex flex-wrap gap-2">
              {PRESET_COLORS.map((c) => (
                <Button
                  key={c}
                  type="button"
                  variant="ghost"
                  size="icon"
                  onClick={() => setColor(c)}
                  className="h-7 w-7 rounded-full border-2 p-0 transition-transform hover:scale-110 hover:bg-transparent"
                  style={{
                    backgroundColor: c,
                    borderColor: color === c ? "#1e293b" : "transparent",
                  }}
                  aria-label={c}
                />
              ))}
            </div>
            {/* Hex input + live preview swatch */}
            <div className="flex items-center gap-2">
              <span
                className="h-7 w-7 shrink-0 rounded-full border border-slate-200"
                style={{ backgroundColor: color }}
              />
              <Input
                value={color}
                onChange={(e) => setColor(e.target.value)}
                placeholder="#64748B"
                className="font-mono text-[13px]"
                maxLength={7}
              />
            </div>
          </div>
          {errors.color && <FormMessage>{errors.color}</FormMessage>}
        </FormItem>

        <FormItem>
          <FormLabel>Description <span className="text-slate-400 font-normal">(optional)</span></FormLabel>
          <Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What is this tag for?"
            rows={3}
            className="resize-none"
          />
        </FormItem>

      </div>

      <div className="flex justify-end gap-3 border-t border-slate-100 px-6 py-4">
        <Button type="button" variant="outline" onClick={onCancel} disabled={isPending}>
          Cancel
        </Button>
        <Button type="submit" disabled={isPending}>
          {isPending ? "Saving…" : tag ? "Save changes" : "Create tag"}
        </Button>
      </div>
    </form>
  )
}
